import React from 'react';
import { DashboardLayout } from '../components/DashboardLayout';
import { Wizard } from '../components/Wizard';

export const WizardPage: React.FC = () => {
  return (
    <DashboardLayout>
      <div className="wizard-dashboard-page">
        {/* Wizard Main Flow */}
        <Wizard />
      </div>
    </DashboardLayout>
  );
};
